export default function (theme) {
    return {
        MuiOutlinedInput: {
            root: {
                margin: [[8, 0, 0, 0]]
            },
            input: {
                padding: 14,
            },
            notchedOutline: {
                borderStyle: 'solid',
                borderWidth: 1,
            }
        }
    };
}